// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-minor-btn[data-v-804cfd4c]{gap:6px;padding:12px 12px;border-radius:10px;width:-moz-fit-content;width:fit-content}.delete-minor-btn[data-v-804cfd4c]:hover{background:#f0f3f7}.minor-title[data-v-804cfd4c]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
